/**
 * Enum representing the source of a data element or remark.
 */
export enum Source {
  FAA = 1,
  AOPA = 2,
  Admin = 3,
  Member = 4,
  AirportManager = 5,
  BusinessManager = 6,
  CustomerService = 7,
  Enterprise = 8,
  _100LL = 9,
  CaribbeanGuide = 10,
  iFlightPlanner = 11,
  BahamasGuide = 12
}


/**
 * Interface representing information about a source, including the full name, abbreviation, and tooltip text.
 */
export interface SourceInfo {
  abbr: string;
  text: string;
  tooltip: string;
  url?: string;
}


/**
 * Maps source identifiers to information about the source.
 */
export const SOURCE_MAPPINGS = new Map<Source, SourceInfo>([
  [Source.FAA, {
    abbr: 'FAA',
    text: 'Federal Aviation Administration',
    tooltip: 'This data was provided by the Federal Aviation Administration.'
  }],
  [Source.AOPA, {
    abbr: 'AOPA',
    text: 'AOPA',
    tooltip: 'This data was provided by AOPA.'
  }],
  [Source.Admin, {
    abbr: 'ADMIN',
    text: 'Admin',
    tooltip: 'This data was provided by an AOPA admin.'
  }],
  [Source.Member, {
    abbr: 'MBR',
    text: 'Member',
    tooltip: 'This data was provided by an AOPA member.'
  }],
  [Source.AirportManager, {
    abbr: 'AM',
    text: 'Airport Manager',
    tooltip: 'This data was provided by the airport manager.'
  }],
  [Source.BusinessManager, {
    abbr: 'BUS MGR',
    text: 'Business Manager',
    tooltip: 'This data was provided by the business manager.'
  }],
  [Source.CustomerService, {
    abbr: 'CUS',
    text: 'Customer Service',
    tooltip: 'This data was provided by AOPA customer service.'
  }],
  [Source.Enterprise, {
    abbr: 'ENT',
    text: 'Enterprise Partner',
    tooltip: 'This data was provided by an Enterprise partner.'
  }],
  [Source._100LL, {
    abbr: '100LL.com',
    text: '100LL.com',
    tooltip: 'This data was provided by 100LL.com',
    url: 'http://www.100ll.com'
  }],
  [Source.CaribbeanGuide, {
    abbr: 'Caribbean',
    text: 'Caribbean Guide',
    tooltip: 'This data was provided by the Caribbean Guide.'
  }],
  [Source.iFlightPlanner, {
    abbr: 'iFlightPlanner',
    text: 'iFlightPlanner',
    tooltip: 'This data was provided by iFlightPlanner.',
    url: 'https://www.aopa.org/travel/fuel-prices'
  }],
  [Source.BahamasGuide, {
    abbr: 'Bahamas',
    text: 'Bahamas Guide',
    tooltip: 'This data was provided by by the Bahamas Guide.'
  }]
]);
